import { Subscription } from 'rxjs';
import { StatesService } from './../../services/states.service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CustomerService } from '../../services/customer.service';
import { ChartType, ChartOptions } from 'chart.js';
import { MultiDataSet, Label, Color } from 'ng2-charts';

@Component({
  selector: 'dash-avaliacoes',
  templateUrl: './avaliacoes.component.html',
  styleUrls: ['./avaliacoes.component.scss'],
})
export class AvaliacoesComponent implements OnInit {
  @Output() graphScreen = new EventEmitter();
  private subscription: Subscription;
  public loading: boolean;
  public avaliacaoList: any;
  public nps: number;
  public dateSetup: any;

  //Propriedades para configurar grafico
  //========================================
  public doughnutChartLabels: Label[] = [
    ' Detratores',
    ' Passivos',
    ' Promotores',
  ];
  public doughnutChartData: MultiDataSet = [];
  public doughnutChartType: ChartType = 'doughnut';
  public doughnutChartOption: ChartOptions = {
    rotation: 0.8 * Math.PI,
    circumference: 1.4 * Math.PI,
    cutoutPercentage: 85,
    responsive: true,
    maintainAspectRatio: false,
    legend: { display: false },
  };
  public doughnutChartColors: Color[] = [
    {
      backgroundColor: [
        'rgb(255, 115, 115)',
        'rgb(255, 191, 45)',
        'rgb(0, 201, 151)',
      ],
    },
  ];

  constructor(
    private _customerService: CustomerService,
    private _stateService: StatesService
  ) {
    this.loading = true;
    this.avaliacaoList = [];
  }

  transformDate(date) {
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const firstDate = new Date(); // hoje
    const secondDate = new Date(date); // data que vem da lista
    const diffDays = Math.round(
      Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay)
    );
    return diffDays;
  }

  openGraphScreen() {
    this.graphScreen.emit();
  }

  ngOnInit(): void {
    this.subscription = this._stateService.currentDate.subscribe((res) => {
      this.dateSetup = res;
      this._customerService
        .getCustomersEvaluation(
          this.dateSetup.start_date,
          this.dateSetup.end_date
        )
        .subscribe((data) => {
          this._stateService.changeEvaluations(data);
          this._stateService.currentEvaluations.subscribe((res) => {
            console.log(res);
            this.doughnutChartData = [
              res.num_detrator,
              res.num_passivo,
              res.num_promotor,
            ];
            this.nps = res.nps;
            this.avaliacaoList = res.comments;
            this.loading = false;
          });
        });
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
